"use client";

type ConversationCreditsExplainerProps = {
  compact?: boolean;
  className?: string;
};

export function ConversationCreditsExplainer({
  compact = false,
  className = "",
}: ConversationCreditsExplainerProps) {
  if (compact) {
    return (
      <div className={`text-xs text-stone-500 space-y-1 ${className}`}>
        <p>
          <strong className="font-medium text-stone-700">1 credit</strong> covers up to 15 minutes
          of AI conversation. Creating and sharing Proxies does not use credits. Each proxy includes
          1 free Preview; additional Previews use 1 credit each.
        </p>
      </div>
    );
  }

  return (
    <div className={`text-sm text-stone-600 space-y-3 ${className}`}>
      <h4 className="font-medium text-stone-900">How conversation credits work</h4>
      <p>
        <strong className="font-medium text-stone-800">1 credit</strong> covers up to 15 minutes of
        AI conversation.
      </p>
      <p>Choose how long each Proxy can talk:</p>
      <ul className="space-y-1 text-stone-600">
        <li>
          <strong className="font-medium text-stone-800">15 min</strong> → 1 credit
        </li>
        <li>
          <strong className="font-medium text-stone-800">30 min</strong> → 2 credits
        </li>
      </ul>
      <p>
        Creating and sharing AI Proxies doesn&apos;t use credits.{" "}
        <strong className="font-medium text-stone-800">
          Credits are used when someone starts a conversation with your AI Proxy. Each proxy
          includes 1 free Preview; additional Previews use 1 credit each.
        </strong>
      </p>
    </div>
  );
}
